import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  holidays: [],
  error: null,
  message: '',
};

const Holidays = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_HOLIDAYS_REQUEST:
    case actionTypes.DELETE_HOLIDAYS_REQUEST:
    case actionTypes.UPLOAD_HOLIDAYS_REQUEST:
    case actionTypes.MULTIDELETE_HOLIDAYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_HOLIDAYS_SUCCESS:
    case actionTypes.DELETE_HOLIDAYS_SUCCESS:
    case actionTypes.UPLOAD_HOLIDAYS_SUCCESS:
    case actionTypes.MULTIDELETE_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        holidays: action.payload,

      }
    case actionTypes.GET_HOLIDAYS_FAILURE:
    case actionTypes.UPDATE_HOLIDAYS_FAILURE:
    case actionTypes.DELETE_HOLIDAYS_FAILURE:
    case actionTypes.UPLOAD_HOLIDAYS_FAILURE:
    case actionTypes.MULTIDELETE_HOLIDAYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Holidays;
